import LogsApp from './Functionality/LogsApp';
import HeadTittle from '../../../components/HeadTittle';
import AccessLogsTab from './Subcomponents/AccessLogsTab';
import { permissionObj } from '../../../Helpers/permission';
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import routes from "../../../Routes/routes";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const Logs = () => {
    const {
        modified,
        setModified,
        finalArray,
        DEV,
        permission,
        navigate,
        moduleId,
        option,
        bodyForExport,
        setBodyForExport,
    } = LogsApp();

    const hasExportPermission = DEV || permission?.includes(permissionObj?.WEB_LOG_PLATFORM_EXPORT);
    // The body carries the model of the view, without it the export request is rejected
    const canExport = hasExportPermission && bodyForExport !== null;

    if (!DEV && !permission?.includes(permissionObj?.WEB_LOG_PLATFORM_READ))
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'logs'}>
                {canExport && (
                    <ExportDataBtn
                        id={'btn_lgs_export'}
                        moduleId={moduleId}
                        body={bodyForExport}
                        option={option}
                        search={true}
                    />
                )}
            </HeadTittle>

            <AccessLogsTab
                finalArray={finalArray}
                modified={modified}
                setModified={setModified}
                setBodyForExport={setBodyForExport}
            />
        </>
    );
};

export default Logs;
